import twemoji from '@twemoji/api';
import svgPackage from '@twemoji/svg/package.json';

// The SVGs are served by the app, from the same package, under the path the
// server writes into the pages it renders (Twemoji in app/lib). The server
// draws the emoji of a page before it leaves; this is for what React renders
// afterwards. Takes a node, rewritten in place, or a string, returned as HTML.
const options = {
  callback: icon => `/twemoji/${svgPackage.version}/${icon}.svg`
};

export const parseEmoji = target => twemoji.parse(target, options);
